import React from 'react'
import { FiPlusCircle } from 'react-icons/fi'
import { icosIndicators } from '../app/Paths'

export const CardSummary = ({ title, value, icon, type }) => {
    return (
        <div className="card">
            <div className="card-body">
                <div className="row mb-2">
                    <div className="col mt-0">
                        <h4 className="fw-bold text-black">{title}</h4>
                    </div>
                    <div className="col-auto">
                        <div className="stat text-primary">
                          <img src={icosIndicators[icon]} className="img-fluid" width={26} alt="tool" />
                        </div>
                    </div>
                </div>
                <div className='text-center'>
                    <h1 className="mt-1 mb-1 text-muted fw-bold">

                        {
                            (type != 1) ? <>{value}</> : <>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value)}</>
                        }

                    </h1>
                </div>
            </div>
        </div>
    )
}
